<!-- 滚轮横向滚动组件 -->
<template>
  <div class="horwheel-img">
    <div id="skill">
      <!-- 底图部分 -->
      <img id="skill-long-img" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/2/bg.jpg" />
      <!-- 前言 -->
      <div data-alt="speed" class="absolute left-0" data-wd="628" data-left="144" data-top="168">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/2/title.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="463" data-left="1498" data-top="513">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/2/talk4.png" class="width-100" />
      </div>
      <div data-alt="speed" class="absolute left-0 opacity-0" data-wd="180" data-left="1391" data-top="498" data-active="ani3" data-left-percentage="0.6" id="skill-talk1">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/cz.gif" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="779" data-left="1970">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/person3.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0 cursor-pointer" data-wd="383" data-left="2493" data-top="239" @click="showModal('xj')">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/play-mp4.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani3" data-left-percentage="0.9" data-wd="781" data-left="6568" data-top="113">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/person1.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani3" data-left-percentage="0.9" data-wd="899" data-left="5327" data-top="0">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/3/pic1.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani3" data-left-percentage="0.9" data-wd="924" data-left="5765">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/3/pic2.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.8" data-wd="463" data-left="4000" data-top="283">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/2/talk1.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-wd="858" data-left="4422">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/person2.png" class="width-100" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.8" data-wd="589" data-left="5091" data-top="666">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/3/talk3.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0" data-active="ani1" data-left-percentage="0.8" data-wd="613" data-left="7204" data-top="269">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/4/talk2.png" class="width-100 opacity-0" />
      </div>

      <div data-alt="speed" class="absolute left-0 cursor-pointer" data-wd="470" data-left="8310" data-top="461" @click="showMp3('skill-ganyan')">
        <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/skill/2/ganyan.png" class="width-100 cursor-pointer" />
      </div>
    </div>
    <img v-if="showMouseTip" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mouse.png" class="mouse-tip ani-opacity" />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// 横向滚动视差滚动对象
let parallax = {
  segment: 15,
  screenWidth: 0,
  dom: null,
  speed: 0.5,
  scrollLeft: 0,
  scrollLeftWithScreen: 0,
  scrollMaxLeft: 0,
  wheelStep: 0,
  minStep: 0,
  curStep: 0,
  longImgWidth: 0,
  longImgRealWidth: 9343,
  longImgRealHeight: 1080,
  imgScale: 1,
  layers: [],
  staticDoms: [],
  music: [],
  extraDom: []
}
let timer
let doingNextMove = false
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      showMouseTip: true,
      end: false
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    reset() {
      if (this.showMouseTip) return
      this.end = false
      this.showMouseTip = true
      parallax.layers = []
      parallax.staticDoms = []
      parallax.music = []
      parallax.extraDom = []
      parallax.dom.style.transform = `translate3d(0, 0, 0)`
      parallax.scrollLeft = 0
      parallax.curStep = 0
      this.init()
    },
    init() {
      this.aniInit()
      this.wheelInit()
    },
    showMp3(mode) {
      const items = [' 首先是感动，第二是敬佩，第三感到振奋人心！我强烈地感受到，对于技能人才而言，这是有奋斗、有礼遇、有未来的时代，这是最好的时代！']
      const name = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/ganyan/zsj/name.png'
      const avatar = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/ganyan/zsj/avatar.png'
      const mp3Gif = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/mp3/fpj.gif'
      const color = '#2754bf'
      const dang = '大国工匠'
      this.$emit('openMp3Modal', { mode, items, name, avatar, mp3Gif, color, dang })
    },
    showModal(mode) {
      let backgroundColor = ''
      let titleImg = ''
      let videoUrl = ''
      if (mode === 'xj') {
        backgroundColor = '#f4bc45'
        titleImg = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/wang/modal-title.png'
        videoUrl = 'https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/video/skill/xj.mp4'
      }
      this.$emit('openModal', { mode, backgroundColor, titleImg, videoUrl })
    },
    aniInit() {},
    wheelInit() {
      // 获取监听滚轮事件
      parallax.dom = document.getElementById('skill')
      // 获取主要滚动dom
      const image = document.getElementById('skill-long-img')
      // console.log('image.width：', image.width)
      parallax.longImgWidth = image.width
      parallax.dom.style.width = image.width + 'px'
      parallax.imgScale = image.width / parallax.longImgRealWidth
      // 获取屏幕宽度
      parallax.screenWidth = window.innerWidth || (document.body && document.body.clientWidth)
      // 最大滚动到左侧距离
      parallax.scrollMaxLeft = parallax.longImgWidth - parallax.screenWidth
      // 每一次距离(屏幕宽度 / 15 * 速率)
      parallax.wheelStep = (parallax.screenWidth / parallax.segment) * parallax.speed
      // 滚动最小距离
      parallax.minStep = parallax.screenWidth / 1000 / parallax.segment
      // 获取滚动到长图的距离 首次进入就是宽度
      parallax.scrollLeftWithScreen = parallax.screenWidth
      // 获取所有要滚动的图片
      this.initChildren()
      console.log('skill-parallax:', parallax)
      // 添加滚轮监听事件
      parallax.dom.addEventListener('wheel', this.handleWheel)
    },
    initPosition(element) {
      const realWidth = element.getAttribute('data-wd')
      const realLeft = element.getAttribute('data-left')
      const realTop = element.getAttribute('data-top')
      if (element.hasAttribute('data-wd')) {
        element.style.width = (realWidth / parallax.longImgRealWidth) * 100 + '%'
      }
      element.style.left = (realLeft / parallax.longImgRealWidth) * 100 + '%'
      if (element.hasAttribute('data-top')) {
        element.style.top = (realTop / parallax.longImgRealHeight) * 100 + '%'
      } else {
        element.style.bottom = 0
      }
    },
    initChildren() {
      // 配置图片
      for (let i = 0; i < parallax.dom.children.length; i++) {
        const element = parallax.dom.children[i]
        if (element.getAttribute('data-alt') === 'speed') {
          // 处理动态
          const speed = element.getAttribute('speed') || 1.1
          const realWidth = element.getAttribute('data-wd')
          const realLeft = element.getAttribute('data-left')
          const realTop = element.getAttribute('data-top')
          let left = realLeft * parallax.imgScale
          left += left / 15
          const layer = {
            dom: element,
            realWidth,
            realLeft,
            speed: Number(speed),
            width: realWidth * parallax.imgScale,
            left: left,
            initLeft: left
          }
          parallax.layers.push(layer)
          // 处理div节点样式
          element.style.width = layer.width + 'px'
          if (element.hasAttribute('data-top')) {
            element.style.top = (realTop / parallax.longImgRealHeight) * 100 + '%'
          } else {
            element.style.bottom = 0
          }
          element.style.transform = `translate3d(${layer.left}px, 0, 0)`
          // 处理内层动画节点样式
          const imgDom = element.children[0]
          const activeClass = element.getAttribute('data-active')
          if (!activeClass) continue
          if (imgDom.classList.contains(activeClass)) {
            imgDom.classList.remove(activeClass)
          }
          const leftPercentage = element.getAttribute('data-left-percentage') || 0.7
          parallax.staticDoms.push({
            dom: imgDom,
            activeClass,
            leftPercentage,
            active: false
          })
        } else if (element.alt === 'static') {
          // 处理静态
          this.initPosition(element)
          const activeClass = element.getAttribute('data-active')
          if (!activeClass) continue
          if (element.classList.contains(activeClass)) {
            element.classList.remove(activeClass)
          }
          parallax.staticDoms.push({
            dom: element,
            activeClass,
            leftPercentage: element.getAttribute('data-left-percentage') || 0.7,
            active: false
          })
        } else if (element.getAttribute('data-alt') === 'position') {
          this.initPosition(element)
        }
      }
      // 初始化音乐
      const musicContainer = document.getElementById('skill-music-contianer')
      const audioElements = musicContainer.getElementsByTagName('audio')
      for (var i = 0; i < audioElements.length; i++) {
        const element = audioElements[i]
        const imgDom = document.getElementById(element.getAttribute('data-img'))
        const activeClass = imgDom.getAttribute('data-active')
        if (imgDom.classList.contains(activeClass)) {
          imgDom.classList.remove(activeClass)
        }
        parallax.music.push({
          dom: element,
          played: false,
          ended: false,
          imgDom: imgDom,
          endPlayLeft: element.getAttribute('data-end-left') * parallax.imgScale,
          leftPercentage: imgDom.getAttribute('data-left-percentage'),
          activeClass
        })
      }
    },
    listenerAnimation() {
      // 获取所有静态dom
      const { screenWidth } = parallax
      for (let i = 0; i < parallax.staticDoms.length; i++) {
        const item = parallax.staticDoms[i]
        if (item.active) continue
        const element = item.dom
        if (element.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          element.classList.add(item.activeClass)
          item.active = true
        }
      }
      // 获取所有音乐dom
      for (let i = 0; i < parallax.music.length; i++) {
        const item = parallax.music[i]
        const imgDom = item.imgDom
        // 已经结束的就跳过
        if (item.ended) continue
        // 正在播放的需要判断结束位置
        if (item.played) {
          //判断停止位置是否到达
          if (parallax.scrollLeftWithScreen >= item.endPlayLeft) {
            this.$emit('playAudio', item.dom)
            item.ended = true
          }
          continue
        }
        if (imgDom.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          this.$emit('playAudio', item.dom)
          item.played = true
          if (item.activeClass) {
            imgDom.classList.add(item.activeClass)
          }
        }
      }
      // 获取所有特殊的dom
      for (let i = 0; i < parallax.extraDom.length; i++) {
        const item = parallax.extraDom[i]
        if (item.active) continue
        const element = item.dom
        if (element.getBoundingClientRect().left < screenWidth * item.leftPercentage) {
          item.active = true
          item.beginAni && item.beginAni()
        }
      }
    },
    handleWheel(event) {
      if (this.showMouseTip) {
        this.showMouseTip = false
      }
      event.preventDefault()
      // 监听动画效果
      this.listenerAnimation()
      // 判断是否前进后退
      const isForward = event.wheelDeltaY < 0
      // 根据滚动距离修改当前位置
      parallax.curStep = parallax.curStep + (isForward ? 1 : -1) * parallax.wheelStep
      // 限制移动范围，防止移动超出图片边界
      parallax.curStep = Math.max(0, Math.min(parallax.curStep, parallax.scrollMaxLeft))
      if (!this.end && parallax.curStep === parallax.scrollMaxLeft) {
        this.end = true
        this.$emit('end')
      }
      // console.log(parallax.curStep)
      doingNextMove = true
      timer || (timer = setInterval(() => this.changeScrollLeft(), 17))
    },
    changeScrollLeft() {
      const step = (parallax.curStep - parallax.scrollLeft) / parallax.segment
      // 如果滚动步长的绝对值大于设定的最小步长。
      if (Math.abs(step) > parallax.minStep) {
        parallax.scrollLeft += step
        parallax.scrollLeftWithScreen += step
        parallax.dom.style.transform = `translate3d(${-parallax.scrollLeft}px, 0, 0)`
        // 调整layers
        for (let i = 0; i < parallax.layers.length; i++) {
          const layer = parallax.layers[i]
          if (layer.speed > 0 && layer.speed < 1) {
            layer.left = layer.initLeft + parallax.scrollLeft * (1 - layer.speed)
          } else {
            layer.left = layer.initLeft - parallax.scrollLeft * (layer.speed - 1)
          }
          layer.dom.style.transform = `translate3d(${layer.left}px, 0, 0)`
        }
      } else if (doingNextMove) {
        console.log('doingNextMove')
        // 如果当前滚动步长小于等于最小步长，并且标志表明有下一个移动要进行。
        doingNextMove = false
        clearInterval(timer)
        timer = null
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // console.log('created');
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.wheelInit();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    if (timer) {
      clearInterval(timer)
    }
    parallax.dom.removeEventListener('wheel', this.handleWheel)
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.horwheel-img {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  #skill {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #76c5ff;
  }
  #skill-long-img {
    height: 100%;
  }

  .mouse-tip {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 7%;
    transform: translate(-50%, -50%);
  }

  .img-speed-bg {
    position: absolute;
    left: 0;
  }
  .img-static-bg {
    position: absolute;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Skill/index.vue